import { styled } from "@mui/material";

const PageWrapper = styled('div')(() => ({
  zIndex: 1,
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  backgroundColor: 'transparent',
  overflowX: 'hidden',
}));

export default PageWrapper;